const LOGIN = 'LOGIN';
const AFFILIATE_INFO = 'AFFILIATE_INFO';
const ALL_ADDRESSES = 'ALL_ADDRESSES';
const TRACKING_ID = 'TRACKING_ID';
const CATEGORY = 'CATEGORY';

export { LOGIN, AFFILIATE_INFO, ALL_ADDRESSES, TRACKING_ID, CATEGORY };